import React from 'react';

import SparkLine from '../../graph/spark-line/SparkLine';
import JSONtoChartData from '../../../container/json-to-chartdata/JSONtoChartData';
import icon_up from '../../../../img/icon_up.gif';
import icon_down from '../../../../img/icon_down.gif';

import './QuickTopKeywordTable.css';
// import Column from '../../graph/column/Column';

const QuickSpark = React.memo((props)=>{
  const title = props.item['keyword'];
  const data = JSONtoChartData({data:props.item, type:"sparkLine"});
  return (
    <SparkLine width="100%" height={60} title={title} data={data} />
  )
})

const QuickTopKeywordTable = (props) => {
  const dataArray=props.data;

  const CompareMark = ({value}) => {
    if(value==='new'){
      return (
        <span className="new">NEW</span>
      )
    }
    else if(value==='up'){
      return(
        <img src={icon_up} align="absmiddle" />
      )
    }
    else if(value==='down'){
      return(
        <img src={icon_down} align="absmiddle" />
      )
    }
    else {
      return(
        <span className="new">-</span>
      )
    };
  }

  return (
    <>
      <table className="tablesty_Noline">
        <tr>
          <td width="100%">
            <table className="dailyKeyword">
              {dataArray['trend-list'].map((item, index) => {
                return(
                  <tr onClick={()=>props.handleOnClick(item, index)}>
                    <td width="50%">
                      <QuickSpark item={item}/>
                    </td>
                    {/* <td width="35%">
                      <Column width="100%" height={60} title={item['keyword']} data={JSONtoChartData({data:item, type:"sparkLine"})} />
                    </td> */}
                    {/* <td width="6%">
                      <Pie width="100%" height={60} data={JSONtoChartData({data:item, type:"sparkLine"})} />
                    </td> */}
                    <td width="5%">{`${index+1}.`}</td>
                    <td width="40%">{item['keyword']}</td>
                    <td width="5%">
                      <CompareMark value={item['compare-value']} />
                    </td>
                  </tr>
                )})}
            </table>
          </td>
        </tr>
      </table>
    </>
  )
}

export default QuickTopKeywordTable;